// Pantheon (SELF) screen help (the "?" above the CURRENT / DEITY / MALADY buttons). Plain words;
// keep it in step with the screen (apps/mobile/src/v10/SelfView.tsx).
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const pantheonHelp: ScreenHelpContent = {
  title: 'The Pantheon',
  intro:
    "The Pantheon is a round hall of deities. Each deity stands for one part of how you run your life, and the hall shows who is standing with you right now. Tap a figure to talk to it.",
  sections: [
    {
      heading: 'The three floors',
      body: ['The three buttons on the left edge (ORDER, SHAPE, PAN) are the floors. Tap one and the hall slides to that floor.'],
      items: [
        { term: 'ORDER', text: 'the deities of your daily routine. Five rooms: Orient, Regulate, Direct, Execute and Revise.' },
        { term: 'SHAPE', text: 'one deity for each of your five life areas. The rooms are named after the areas: Social, Health, Admin, Personal and Economic. An empty podium means no deity has been picked for that area yet. Its Goal in ATLAS decides who stands there.' },
        { term: 'PAN', text: 'the Council. Its five podiums are seats, and you choose who sits on them. See "The Council" below.' },
      ],
    },
    {
      heading: 'Turning the hall',
      body: [
        'The curved bar across the top is a dial with three stops. Tap a stop, or swipe sideways, and the whole hall turns to it.',
        'On ORDER the stops are ORDER 1, ORDER 2 and ORDER 3. Each one is a row of five deities, one per room, and they go up in rank from ORDER 1 to ORDER 3. The hall starts on the one you are working on. On SHAPE you land on GROUP 2. On PAN you land on COUNCIL. A stop with a padlock is locked and the hall will not turn to it yet.',
      ],
    },
    {
      heading: 'Who is standing there',
      body: ['The three buttons on the right edge choose who stands on each podium. Each podium holds a deity and a malady, the unhelpful pattern that works against it.'],
      items: [
        { term: 'CURRENT', text: "whoever holds the seat right now, from what you have actually been doing lately. The malady only shows when it is out-scoring the deity. Otherwise you see the deity." },
        { term: 'DEITY', text: 'always the deity.' },
        { term: 'MALADY', text: 'always the malady. SHAPE deities have no maladies yet, so those podiums stay bare.' },
      ],
    },
    {
      heading: 'Talking to a deity',
      body: [
        "Tap a figure to open it. You talk to it by voice or by text, and it answers.",
        'The deity that fits your current Step has a soft glow around it.',
      ],
    },
    {
      heading: 'The Council',
      body: [
        'On the PAN floor, tap an empty podium (+) to choose who sits there. SyQi is one of the choices.',
        'Tap someone who is seated for a menu: Nudge to speak, Mute or Unmute, Talk one-on-one, Change who sits here, Remove from council. A "…" over a figure means it is thinking. MUTED means it will stay quiet.',
        'Type in the box at the bottom, or use the mic button. The conversation shows in the middle of the hall. At the top you can tap the council name to rename it, and Pause or Resume it.',
        'The buttons down the right edge leave the council, turn Conference on or off (replies read aloud), and open past council sessions. How the council behaves is set in Settings, under General, then Council.',
      ],
    },
    {
      heading: 'Moving around',
      body: ['The ▼ arrow at the bottom takes you back down to the compass.'],
    },
  ],
};
